import React from 'react';

const FifthPage = () => {
  return (
    <div className="page-section">
      <div className="container mt-4">
        <div className="row align-center">
          <div className="col-md-12 text-center title-text">
            Những lợi ích của NAD+
          </div>
        </div>
        <div className="row align-center mt-2">
          <div className="col-md-12 text-center">
            <img src="/images/nad3-2.png" alt="Product" className="img-fluid" style={{ width: '100%', maxWidth: '1000px' }} loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FifthPage;  